module.exports = __webpack_public_path__ + "img/figure-2.957cb64e.png";